module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-500.2f054285.png";